import {
  createRootRoute,
  Outlet,
  useRouterState,
} from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";

export const Route = createRootRoute({
  component: () => {
    const { location } = useRouterState();
    // Public, unauthenticated routes render without the app shell.
    if (
      location.pathname.startsWith("/login") ||
      location.pathname.startsWith("/r/")
    )
      return <Outlet />;
    return <AppShell />;
  },
});
